import { AlertTriangleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useScenarioQuery } from '@/entities/scenario'

import {
	Alert,
	AlertDescription,
	AlertTitle,
} from '@/shared/components/ui/alert'
import { Skeleton } from '@/shared/components/ui/skeleton'

import { ScenarioBusinessSettingsCard } from './ScenarioBusinessSettingsCard'
import { ScenarioPricingCampaigns } from './ScenarioPricingCampaigns'
import { ScenarioStopListSettingsCard } from './ScenarioStopListSettingsCard'
import { ScenarioStrategySettingsCard } from './ScenarioStrategySettingsCard'

export const ScenarioSettingsTab = ({ scenarioId }: { scenarioId: string }) => {
	const { t } = useTranslation()

	const scenarioQuery = useScenarioQuery(scenarioId, {
		enabled: !!scenarioId,
	})
	if (scenarioQuery.isLoading) {
		return (
			<div className='flex w-full flex-col gap-2 p-4'>
				<Skeleton className='h-32 w-full' />
				<Skeleton className='h-48 w-full opacity-30' />
				<Skeleton className='h-52 w-full opacity-10' />
			</div>
		)
	}
	if (scenarioQuery.isError) {
		return (
			<div className='w-full p-4'>
				<Alert variant='destructive'>
					<AlertTriangleIcon />
					<AlertTitle>
						{t('app.unexpected_error', { defaultValue: 'Unexpected error' })}
					</AlertTitle>
					<AlertDescription>
						{t('app.scenarios_fetch_error', {
							defaultValue:
								'Something went wrong while fetching the scenario, please try again later or contact support.',
						})}
					</AlertDescription>
				</Alert>
			</div>
		)
	}

	return (
		<div className='flex h-full flex-col gap-4 overflow-y-auto px-4 pt-2 pb-4'>
			<ScenarioStrategySettingsCard
				settings={scenarioQuery.data?.settings?.strategy}
			/>
			<ScenarioBusinessSettingsCard
				settings={scenarioQuery.data?.settings?.business}
			/>
			<ScenarioStopListSettingsCard
				settings={scenarioQuery.data?.settings?.stop_list}
			/>
			<ScenarioPricingCampaigns scenarioId={scenarioId} />
		</div>
	)
}
